// Itineraries + editorial blocks + brand pillars for the
// /viajes/surdemarruecos gateway page. Focus: Sahara, Atlas,
// kasbahs, oasis and the Atlantic gem of Essaouira.

export const SUR_ITINERARIES = [
  {
    id: "ouarzazate-erg-chebbi",
    slug: "ouarzazate-erg-chebbi",
    hubId: "atlas-desierto",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    title: {
      es: "Ouarzazate · Cordillera Alto Atlas · Dunas Erg Chebbi · Errachidia",
      en: "Ouarzazate · High Atlas range · Erg Chebbi dunes · Errachidia",
      fr: "Ouarzazate · Cordillère du Haut Atlas · Dunes de l'Erg Chebbi · Errachidia",
    },
    duration: { es: "Varias duraciones disponibles", en: "Multiple durations", fr: "Plusieurs durées" },
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=2200&q=85",
    accent: "#C16542",
    stages: [
      { es: "Ouarzazate",      en: "Ouarzazate",      fr: "Ouarzazate" },
      { es: "Alto Atlas",      en: "High Atlas",      fr: "Haut Atlas" },
      { es: "Poblados Imazighen", en: "Imazighen villages", fr: "Villages imazighen" },
      { es: "Puerta del desierto", en: "Desert gate", fr: "Porte du désert" },
      { es: "Erg Chebbi",      en: "Erg Chebbi",      fr: "Erg Chebbi" },
      { es: "Errachidia",      en: "Errachidia",      fr: "Errachidia" },
    ],
    body: {
      es: [
        "¿Quieres desconectar unos días y vivir una experiencia mágica?",
        "Te proponemos una escapada hacia el gran Erg Chebbi, el desierto de dunas más cercano a Europa, situado en el sur de Marruecos.",
        "La ruta comienza en la cordillera del Alto Atlas, recorriendo en vehículo 4x4 algunos poblados Imazighen donde el tiempo parece haberse detenido.",
        "Atravesaremos valles, oasis y gargantas hasta llegar a la «puerta del desierto», donde la magia del Sahara empieza a sentirse en cada paisaje.",
        "Las tradiciones ancestrales de sus gentes, los mercados locales, los colores del desierto y una noche bajo las estrellas convertirán esta experiencia en un viaje inolvidable.",
      ],
      en: [
        "Want to disconnect for a few days and live something truly magical?",
        "We propose an escape to the great Erg Chebbi, the closest dune desert to Europe, in the south of Morocco.",
        "The route begins in the High Atlas range, travelling by 4x4 through Imazighen villages where time seems to have stopped.",
        "We cross valleys, oases and gorges all the way to the «gate of the desert», where the magic of the Sahara starts to seep into every landscape.",
        "The ancestral traditions of its people, local markets, desert colours and a night under the stars turn this experience into an unforgettable journey.",
      ],
      fr: [
        "Envie de déconnecter quelques jours et vivre une expérience magique ?",
        "Nous vous proposons une escapade vers le grand Erg Chebbi, le désert de dunes le plus proche de l'Europe, dans le sud du Maroc.",
        "La route débute dans la cordillère du Haut Atlas, en 4x4 à travers des villages imazighen où le temps semble s'être arrêté.",
        "Nous traversons vallées, oasis et gorges jusqu'à la « porte du désert », où la magie du Sahara s'imprime dans chaque paysage.",
        "Les traditions ancestrales de ses habitants, les marchés locaux, les couleurs du désert et une nuit sous les étoiles font de cette expérience un voyage inoubliable.",
      ],
    },
  },
  {
    id: "marrakech-erg-chebbi-errachidia",
    slug: "marrakech-erg-chebbi-errachidia",
    hubId: "marrakech-erg",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    title: {
      es: "Marrakech · Cordillera Alto Atlas · Dunas Erg Chebbi · Errachidia",
      en: "Marrakech · High Atlas range · Erg Chebbi dunes · Errachidia",
      fr: "Marrakech · Cordillère du Haut Atlas · Dunes de l'Erg Chebbi · Errachidia",
    },
    duration: { es: "Varias duraciones disponibles", en: "Multiple durations", fr: "Plusieurs durées" },
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2200&q=85",
    accent: "#A07042",
    stages: [
      { es: "Marrakech",  en: "Marrakech",  fr: "Marrakech" },
      { es: "Alto Atlas", en: "High Atlas", fr: "Haut Atlas" },
      { es: "Pueblos bereberes", en: "Berber villages", fr: "Villages berbères" },
      { es: "Erg Chebbi", en: "Erg Chebbi", fr: "Erg Chebbi" },
      { es: "Rissani",    en: "Rissani",    fr: "Rissani" },
      { es: "Errachidia", en: "Errachidia", fr: "Errachidia" },
    ],
    body: {
      es: [
        "Marrakech – Erg Chebbi es un viaje auténtico para descubrir el alma del sur de Marruecos.",
        "La ruta comienza en Marrakech, una ciudad vibrante llena de colores, aromas, plazas históricas, artesanos y artistas que dejan una huella imborrable en el viajero.",
        "Desde la ciudad, el recorrido continúa en 4x4 hacia el Alto Atlas, descubriendo paisajes espectaculares, gargantas inmensas y pequeños pueblos donde la vida transcurre lentamente.",
        "Poco a poco, las montañas dejan paso al desierto del Erg Chebbi, un auténtico espectáculo para los sentidos.",
        "Las interminables dunas y la atmósfera mágica del Sahara permitirán vivir una noche inolvidable bajo las estrellas.",
        "La ruta atraviesa también lugares tan emblemáticos como Rissani y su mercado ancestral, considerado uno de los más auténticos del sur del país.",
      ],
      en: [
        "Marrakech – Erg Chebbi is an authentic journey to uncover the soul of southern Morocco.",
        "The route starts in Marrakech, a vibrant city full of colour, aromas, historic squares, artisans and artists who leave a lasting mark on every traveller.",
        "From the city, the journey continues by 4x4 into the High Atlas, revealing spectacular landscapes, vast gorges and small villages where life moves slowly.",
        "Little by little, the mountains give way to the Erg Chebbi desert — a true feast for the senses.",
        "The endless dunes and magical atmosphere of the Sahara open the way to an unforgettable night under the stars.",
        "The route also crosses emblematic places like Rissani and its ancestral market, considered one of the most authentic in the south of the country.",
      ],
      fr: [
        "Marrakech – Erg Chebbi est un voyage authentique pour découvrir l'âme du sud du Maroc.",
        "L'itinéraire commence à Marrakech, une ville vibrante pleine de couleurs, de parfums, de places historiques, d'artisans et d'artistes qui laissent une empreinte indélébile.",
        "Depuis la ville, le parcours continue en 4x4 vers le Haut Atlas, à la découverte de paysages spectaculaires, d'immenses gorges et de petits villages où la vie s'écoule lentement.",
        "Peu à peu, les montagnes laissent place au désert de l'Erg Chebbi — un véritable spectacle pour les sens.",
        "Les dunes infinies et l'atmosphère magique du Sahara offrent une nuit inoubliable sous les étoiles.",
        "L'itinéraire traverse aussi des lieux emblématiques comme Rissani et son marché ancestral, considéré comme l'un des plus authentiques du sud du pays.",
      ],
    },
  },
  {
    id: "marrakech-erg-chebbi-marrakech",
    slug: "marrakech-erg-chebbi-marrakech",
    hubId: "marrakech-loop",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    title: {
      es: "Marrakech · Cordillera Alto Atlas · Dunas Erg Chebbi · Marrakech",
      en: "Marrakech · High Atlas range · Erg Chebbi dunes · Marrakech",
      fr: "Marrakech · Cordillère du Haut Atlas · Dunes de l'Erg Chebbi · Marrakech",
    },
    duration: { es: "Varias duraciones disponibles", en: "Multiple durations", fr: "Plusieurs durées" },
    image: "https://images.unsplash.com/photo-1547234935-80c7145ec969?auto=format&fit=crop&w=2200&q=85",
    accent: "#D97742",
    stages: [
      { es: "Marrakech",  en: "Marrakech",  fr: "Marrakech" },
      { es: "Alto Atlas", en: "High Atlas", fr: "Haut Atlas" },
      { es: "Pueblos bereberes", en: "Berber villages", fr: "Villages berbères" },
      { es: "Valles & oasis", en: "Valleys & oases", fr: "Vallées & oasis" },
      { es: "Gargantas",  en: "Gorges",     fr: "Gorges" },
      { es: "Erg Chebbi", en: "Erg Chebbi", fr: "Erg Chebbi" },
      { es: "Marrakech",  en: "Marrakech",  fr: "Marrakech" },
    ],
    body: {
      es: [
        "Marrakech – Erg Chebbi – Marrakech es una ruta diseñada para descubrir en profundidad el sur de Marruecos.",
        "El viaje comienza en Marrakech y continúa atravesando el Alto Atlas en vehículo 4x4, recorriendo pueblos bereberes, valles, oasis y gargantas espectaculares.",
        "La ruta permite disfrutar del paisaje sin prisas, conversar con aldeanos locales y descubrir el ritmo auténtico del Marruecos más tradicional.",
        "El desierto del Erg Chebbi ofrece una de las experiencias más memorables del viaje: una noche bajo las estrellas rodeados de dunas infinitas y silencio absoluto.",
      ],
      en: [
        "Marrakech – Erg Chebbi – Marrakech is a circular route designed to discover southern Morocco in depth.",
        "The journey starts in Marrakech and continues across the High Atlas by 4x4, threading Berber villages, valleys, oases and spectacular gorges.",
        "The route lets you enjoy the landscape unhurried, chat with local villagers and discover the authentic rhythm of traditional Morocco.",
        "The Erg Chebbi desert delivers one of the most memorable moments of the trip: a night under the stars surrounded by endless dunes and absolute silence.",
      ],
      fr: [
        "Marrakech – Erg Chebbi – Marrakech est un itinéraire circulaire conçu pour découvrir en profondeur le sud du Maroc.",
        "Le voyage débute à Marrakech et continue à travers le Haut Atlas en 4x4, traversant villages berbères, vallées, oasis et gorges spectaculaires.",
        "L'itinéraire permet de profiter du paysage sans hâte, de discuter avec les villageois et de découvrir le rythme authentique du Maroc traditionnel.",
        "Le désert de l'Erg Chebbi offre l'un des moments les plus mémorables du voyage : une nuit sous les étoiles entouré de dunes infinies et d'un silence absolu.",
      ],
    },
  },
  {
    id: "marrakech-essaouira",
    slug: "marrakech-essaouira",
    hubId: "marrakech-essaouira",
    eyebrow: { es: "Viajes por el Sur de Marruecos", en: "Southern Morocco journeys", fr: "Voyages au Sud du Maroc" },
    title: {
      es: "Marrakech · Essaouira",
      en: "Marrakech · Essaouira",
      fr: "Marrakech · Essaouira",
    },
    duration: { es: "Varias duraciones disponibles", en: "Multiple durations", fr: "Plusieurs durées" },
    image: "https://images.unsplash.com/photo-1597212618440-806262de4f6b?auto=format&fit=crop&w=2200&q=85",
    accent: "#3A4A5F",
    stages: [
      { es: "Marrakech",    en: "Marrakech",    fr: "Marrakech" },
      { es: "Jemaa el-Fna", en: "Jemaa el-Fna", fr: "Jemaa el-Fna" },
      { es: "Zocos",        en: "Souks",        fr: "Souks" },
      { es: "Essaouira",    en: "Essaouira",    fr: "Essaouira" },
      { es: "Atlántico",    en: "Atlantic",     fr: "Atlantique" },
      { es: "Puerto pesquero", en: "Fishing port", fr: "Port de pêche" },
    ],
    body: {
      es: [
        "Te presentamos un combinado entre dos lugares imprescindibles de Marruecos.",
        "Por un lado, Marrakech, con su inigualable Plaza Jemaa el-Fna, sus zocos laberínticos, palacios, jardines y talleres de artesanía.",
        "Por otro lado, Essaouira, una preciosa ciudad costera donde pasear, relajarse y disfrutar del Atlántico en una atmósfera tranquila y auténtica.",
      ],
      en: [
        "A two-city pairing of two essentials of Morocco.",
        "On one hand Marrakech, with its unrivalled Jemaa el-Fna square, its labyrinthine souks, palaces, gardens and craft workshops.",
        "On the other hand Essaouira, a beautiful coastal city where you stroll, relax and enjoy the Atlantic in a calm and authentic atmosphere.",
      ],
      fr: [
        "Une combinaison de deux incontournables du Maroc.",
        "D'un côté Marrakech, avec son incomparable place Jemaa el-Fna, ses souks labyrinthiques, ses palais, ses jardins et ses ateliers d'artisanat.",
        "De l'autre Essaouira, ravissante ville côtière où l'on flâne, se détend et profite de l'Atlantique dans une atmosphère calme et authentique.",
      ],
    },
  },
];

// Editorial narrative essays — interleaved with itineraries for cinematic pacing.
export const SUR_EDITORIAL = [
  {
    id: "mil-kasbahs",
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2200&q=85",
    eyebrow: { es: "Patrimonio del sur", en: "Heritage of the south", fr: "Patrimoine du sud" },
    title: {
      es: "La ruta de las mil kasbahs",
      en: "The route of a thousand kasbahs",
      fr: "La route des mille kasbahs",
    },
    body: {
      es: [
        "La ruta de las mil kasbahs es una de las experiencias más emblemáticas y fascinantes de Marruecos.",
        "Las kasbahs son construcciones tradicionales marroquíes, muchas de ellas elaboradas en adobe y piedra, que se encuentran repartidas por todo el sur del país, entre oasis, valles y antiguas rutas caravaneras.",
        "Esta ruta permite descubrir algunos de los ejemplos más impresionantes de arquitectura tradicional bereber, muchas todavía habitadas hoy en día.",
        "Recorrer la ruta de las mil kasbahs es una forma única de experimentar la cultura marroquí más auténtica y contemplar algunos de los paisajes y arquitecturas más espectaculares del norte de África.",
      ],
      en: [
        "The route of a thousand kasbahs is one of Morocco's most emblematic and fascinating experiences.",
        "Kasbahs are traditional Moroccan buildings, many made of adobe and stone, scattered across the south of the country among oases, valleys and ancient caravan routes.",
        "The route lets you discover some of the most impressive examples of traditional Berber architecture, many of them still inhabited today.",
        "Travelling the route of a thousand kasbahs is a unique way to experience the most authentic Moroccan culture and contemplate some of the most spectacular landscapes and architectures of North Africa.",
      ],
      fr: [
        "La route des mille kasbahs est l'une des expériences les plus emblématiques et fascinantes du Maroc.",
        "Les kasbahs sont des constructions traditionnelles marocaines, souvent en pisé et en pierre, dispersées dans tout le sud du pays — au milieu des oasis, des vallées et des anciennes routes caravanières.",
        "Cette route permet de découvrir certains des plus impressionnants exemples d'architecture berbère traditionnelle, dont beaucoup sont encore habités aujourd'hui.",
        "Parcourir la route des mille kasbahs est une manière unique de vivre la culture marocaine la plus authentique et de contempler certains des paysages et architectures les plus spectaculaires d'Afrique du Nord.",
      ],
    },
  },
  {
    id: "puerta-del-desierto",
    image: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=2200&q=85",
    eyebrow: { es: "Leyenda del Sahara", en: "Sahara legend", fr: "Légende du Sahara" },
    title: {
      es: "La puerta del desierto",
      en: "The gate of the desert",
      fr: "La porte du désert",
    },
    body: {
      es: [
        "En medio del desierto de Merzouga se encuentra una pequeña puerta enterrada entre las dunas.",
        "La llamada «Puerta del Desierto» representa un símbolo lleno de misterio, un portal hacia otro mundo donde el tiempo parece detenerse y la inmensidad del Sahara envuelve cada instante.",
        "Durante siglos, este lugar ha despertado la imaginación de viajeros y nómadas. Algunos creen que conduce a otro reino; otros, que forma parte de las antiguas leyendas del desierto.",
        "Más allá del mito, no se puede negar la energía y el magnetismo que transmite este rincón único del Sahara.",
      ],
      en: [
        "In the middle of the Merzouga desert lies a small door, half-buried between the dunes.",
        "The so-called «Gate of the Desert» is a symbol charged with mystery — a portal to another world where time seems to stop and the immensity of the Sahara wraps every moment.",
        "For centuries this place has stirred the imagination of travellers and nomads. Some believe it leads to another realm; others, that it belongs to the old legends of the desert.",
        "Beyond the myth, there is no denying the energy and magnetism this unique corner of the Sahara transmits.",
      ],
      fr: [
        "Au cœur du désert de Merzouga se trouve une petite porte à demi enfouie entre les dunes.",
        "La fameuse « Porte du Désert » est un symbole chargé de mystère — un portail vers un autre monde où le temps semble s'arrêter et où l'immensité du Sahara enveloppe chaque instant.",
        "Pendant des siècles, ce lieu a éveillé l'imagination des voyageurs et des nomades. Certains croient qu'il mène à un autre royaume ; d'autres, qu'il appartient aux anciennes légendes du désert.",
        "Au-delà du mythe, on ne peut nier l'énergie et le magnétisme que dégage ce coin unique du Sahara.",
      ],
    },
  },
  {
    id: "marrakech-atlas-sahara",
    image: "https://images.unsplash.com/photo-1542401886-65d6c61db217?auto=format&fit=crop&w=2200&q=85",
    eyebrow: { es: "Tres mundos en un viaje", en: "Three worlds in one journey", fr: "Trois mondes en un voyage" },
    title: {
      es: "Marrakech, el Alto Atlas y el Sahara",
      en: "Marrakech, the High Atlas and the Sahara",
      fr: "Marrakech, le Haut Atlas et le Sahara",
    },
    body: {
      es: [
        "Marrakech es una ciudad profundamente pintoresca. Sus edificios decorados con mosaicos tradicionales, las palmeras, los mercados y el aroma de las especias crean una atmósfera única.",
        "La llamada a la oración resuena por toda la ciudad mientras la vida fluye entre zocos, jardines y plazas llenas de historia.",
        "El Alto Atlas, por su parte, es hogar de muchos pueblos bereberes y ofrece algunos de los paisajes más impresionantes de Marruecos.",
        "Y finalmente, el desierto de Merzouga aparece como un mundo completamente diferente.",
        "La arena suave y cálida, los atardeceres ardientes y las noches llenas de estrellas convierten el Sahara en uno de los lugares más mágicos del planeta.",
      ],
      en: [
        "Marrakech is a deeply picturesque city. Its buildings adorned with traditional mosaics, the palm trees, the markets and the aroma of spices create a unique atmosphere.",
        "The call to prayer echoes through the city while life flows between souks, gardens and squares brimming with history.",
        "The High Atlas, in turn, is home to many Berber villages and offers some of the most impressive landscapes in Morocco.",
        "And finally, the Merzouga desert appears as a completely different world.",
        "The soft warm sand, blazing sunsets and starlit nights turn the Sahara into one of the most magical places on the planet.",
      ],
      fr: [
        "Marrakech est une ville profondément pittoresque. Ses bâtiments ornés de mosaïques traditionnelles, ses palmiers, ses marchés et l'arôme des épices créent une atmosphère unique.",
        "L'appel à la prière résonne dans toute la ville tandis que la vie s'écoule entre souks, jardins et places chargées d'histoire.",
        "Le Haut Atlas, quant à lui, abrite de nombreux villages berbères et offre certains des paysages les plus impressionnants du Maroc.",
        "Et enfin, le désert de Merzouga apparaît comme un monde totalement différent.",
        "Le sable doux et chaud, les couchers de soleil ardents et les nuits étoilées font du Sahara l'un des lieux les plus magiques de la planète.",
      ],
    },
  },
  {
    id: "marrakech-essaouira-intro",
    image: "https://images.unsplash.com/photo-1539020140153-e479b8c22e70?auto=format&fit=crop&w=2200&q=85",
    eyebrow: { es: "Dos almas, un país", en: "Two souls, one country", fr: "Deux âmes, un pays" },
    title: {
      es: "Marrakech y Essaouira",
      en: "Marrakech and Essaouira",
      fr: "Marrakech et Essaouira",
    },
    body: {
      es: [
        "Marrakech y Essaouira son dos de los destinos más fascinantes y complementarios de Marruecos.",
        "Marrakech destaca por su energía vibrante, sus mercados, mezquitas, jardines y plazas llenas de vida.",
        "Essaouira, conocida como «La Perla del Atlántico», ofrece una atmósfera completamente distinta: relajada, marítima y artística.",
        "Sus murallas frente al océano, su puerto pesquero y sus playas convierten esta ciudad declarada Patrimonio de la Humanidad por la UNESCO en uno de los rincones más especiales del país.",
      ],
      en: [
        "Marrakech and Essaouira are two of the most fascinating and complementary destinations in Morocco.",
        "Marrakech shines through its vibrant energy, markets, mosques, gardens and squares teeming with life.",
        "Essaouira, known as «The Pearl of the Atlantic», offers a completely different atmosphere: relaxed, maritime and artistic.",
        "Its walls facing the ocean, its fishing port and its beaches turn this UNESCO World Heritage city into one of the most special corners of the country.",
      ],
      fr: [
        "Marrakech et Essaouira sont deux des destinations les plus fascinantes et complémentaires du Maroc.",
        "Marrakech brille par son énergie vibrante, ses marchés, ses mosquées, ses jardins et ses places pleines de vie.",
        "Essaouira, surnommée « La Perle de l'Atlantique », offre une atmosphère totalement différente : détendue, maritime et artistique.",
        "Ses remparts face à l'océan, son port de pêche et ses plages font de cette ville classée au Patrimoine Mondial de l'UNESCO l'un des coins les plus particuliers du pays.",
      ],
    },
  },
];

// Four reasons to travel with Xaluca Tours.
export const SUR_PILLARS = [
  {
    id: "attention",
    icon: "Headphones",
    title: { es: "Asistencia en viaje 24/7", en: "24/7 assistance during your trip", fr: "Assistance en voyage 24h/24 et 7j/7" },
    body: {
      es: "Durante tu estancia en Marruecos dispones de asistencia 24/7 para cualquier necesidad o incidencia relacionada con el viaje. La organización previa y la atención comercial se prestan en horario de oficina.",
      en: "During your stay in Morocco, 24/7 assistance is available for any need or incident related to the trip. Pre-trip planning and customer service are provided during office hours.",
      fr: "Pendant votre séjour au Maroc, vous bénéficiez d’une assistance 24h/24 et 7j/7 pour tout besoin ou incident lié au voyage. La préparation et le service commercial sont assurés pendant les heures de bureau.",
    },
  },
  {
    id: "tailor",
    icon: "Pencil",
    title: { es: "Viajes 100% personalizados", en: "100% tailor-made journeys", fr: "Voyages 100% personnalisés" },
    body: {
      es: "Todos nuestros viajes son a medida. Adaptamos cada experiencia según tu disponibilidad, intereses y actividades deseadas.",
      en: "Every trip is tailor-made. We adapt each experience to your availability, interests and chosen activities.",
      fr: "Tous nos voyages sont sur mesure. Nous adaptons chaque expérience à votre disponibilité, vos centres d'intérêt et vos activités choisies.",
    },
  },
  {
    id: "quality",
    icon: "Award",
    title: { es: "Máxima calidad asegurada", en: "Top-tier quality assured", fr: "Qualité maximale garantie" },
    body: {
      es: "Todos los hoteles, rutas y actividades han sido previamente seleccionados y probados por nuestro equipo para garantizar la máxima calidad.",
      en: "Every hotel, route and activity has been hand-selected and tested by our team to guarantee top-tier quality.",
      fr: "Chaque hôtel, itinéraire et activité a été sélectionné et testé par notre équipe afin de garantir la plus haute qualité.",
    },
  },
  {
    id: "guarantee",
    icon: "ShieldCheck",
    title: { es: "Garantía Grup Xaluca", en: "Grup Xaluca guarantee", fr: "Garantie Grup Xaluca" },
    body: {
      es: "Disponemos de una red de hoteles y campamentos propios en el sur de Marruecos, ofreciendo una experiencia integral y un servicio personalizado de 360 grados.",
      en: "We own a network of hotels and camps across southern Morocco, delivering a complete experience and a 360-degree personal service.",
      fr: "Nous disposons d'un réseau d'hôtels et de campements en propre dans le sud du Maroc, offrant une expérience intégrale et un service personnalisé à 360 degrés.",
    },
  },
];
